<div class="row">
  <div class="col">
    <header class="bg-brand-header fixed-top">
      <div class="container-fluid">
        <div class="row">
          <div class="col">
            <nav class="navbar navbar-expand-lg navbar-light">
              <button
                (click)="toggleNavBar()"
                aria-controls="navbarSupportedContent"
                aria-expanded="false"
                aria-label="Toggle navigation"
                class="navbar-toggler p-0"
                data-target="#navbarSupportedContent"
                data-toggle="collapse"
                type="button"
              >
                <span class="navbar-toggler-icon"></span>
              </button>
              <div class="d-flex">
                @if (!!(logoUrl$ | async)) {
                  <a
                    [href]="logoAnchorUrl$ | async"
                    aria-hidden="true"
                    class="navbar-brand mr-0 no-logo"
                    id="mcBrandLogo"
                    ><img
                      [attr.height]="logoHeight$ | async"
                      [attr.width]="logoWidth$ | async"
                      [src]="logoUrl$ | async"
                      alt=""
                      class="header-logo"
                  /></a>
                }
                <a [href]="logoAnchorUrl$ | async" class="navbar-brand mr-0" id="brandLogo"> </a>
                <a
                  [innerHTML]="siteName$ | async"
                  [style]="siteNameStyle$ | async"
                  class="navbar-brand no-logo"
                  id="brandName"
                  routerLink="/home"
                >
                </a>
              </div>

              <div [ngbCollapse]="isNavBarCollapsed" class="collapse navbar-collapse" id="navbarSupportedContent">
                @if (!isSigningOut) {
                  <ul class="navbar-nav me-auto">
                    <li class="nav-item divider-vertical d-none d-lg-block"></li>
                    <ng-container>
                      <li class="nav-item dropdown">
                        <a
                          (click)="(false)"
                          aria-expanded="false"
                          aria-haspopup="true"
                          class="nav-link dropdown-toggle"
                          data-bs-toggle="dropdown"
                          href=""
                          id="myProductsLinksMenu"
                          role="button"
                          >My Products</a
                        >
                        <div aria-labelledby="myProductsLinksMenu" class="dropdown-menu">
                          <a
                            *appIfFeature="'!data_entitlement_v2'"
                            class="dropdown-item"
                            id="myDataProducts"
                            routerLink="/products"
                            >My Data Products</a
                          >
                          <a
                            *appIfFeature="'data_entitlement_v2'"
                            class="dropdown-item"
                            id="dataProducts"
                            routerLink="/data"
                            >My Data Products</a
                          >
                          <a class="dropdown-item" id="mySoftwareProducts" routerLink="/software"
                            >My Software Products</a
                          >
                        </div>
                      </li>
                    </ng-container>
                    <!--              <li *appHasPermission="'myClients'" class="nav-item">-->
                    <!--                <a class="nav-link" routerLink="/clients">My Clients</a>-->
                    <!--              </li>-->
                    <li class="nav-item">
                      <a class="nav-link" id="samples" routerLink="/samples">Sample Datasets</a>
                    </li>
                    <li class="nav-item dropdown">
                      <a
                        (click)="(false)"
                        aria-expanded="false"
                        aria-haspopup="true"
                        class="nav-link dropdown-toggle"
                        data-bs-toggle="dropdown"
                        href="#"
                        id="navbarDropdownMenuLink"
                        role="button"
                        >Visualize</a
                      >
                      <div aria-labelledby="navbarDropdownMenuLink" class="dropdown-menu">
                        <a
                          *appIfFeature="'map_explorer_v2'"
                          class="dropdown-item"
                          routerLink="/visualization/map-explorer"
                          >Map Explorer</a
                        >
                        <a *appIfFeature="'!hide_demo_sites'" class="dropdown-item" routerLink="/usecases/property-risk"
                          >Property Risk Profile Demo</a
                        >
                        <a
                          *appIfFeature="'!hide_demo_sites'"
                          class="dropdown-item"
                          routerLink="/usecases/home-search-real-estate"
                          >Home Search Real Estate Demo</a
                        >
                      </div>
                    </li>
                  </ul>
                }

                @if (isSigningOut) {
                  <ul class="navbar-nav me-auto"></ul>
                }

                <ul class="navbar-nav navbar-right">
                  @if (!isSigningOut) {
                    <li class="nav-item">
                      <a aria-label="Search" class="nav-link" routerLink="/search">
                        <i aria-hidden="true" class="pbi-icon-outline pbi-search d-lg-inline" id="searchHeader"></i>
                      </a>
                    </li>
                  }

                  @if ((isMasterCardUser$ | async) === false) {
                    <li class="nav-item dropdown">
                      <a
                        aria-expanded="false"
                        aria-haspopup="true"
                        class="nav-link dropdown-toggle"
                        data-bs-toggle="dropdown"
                        href="#"
                        id="communityDropDown"
                      >
                        <i aria-hidden="true" class="pbi-icon-outline pbi-apps d-none d-lg-inline"></i>
                        <span class="d-lg-none" id="app-offscreen">
                          <i aria-hidden="true" class="pbi-icon-mini pbi-grid-4"></i>&nbsp;Applications
                        </span>
                      </a>
                      <div aria-labelledby="communityDropDown" class="dropdown-menu">
                        <div class="section-head hidden-xs">Your Apps</div>
                        <a class="dropdown-item" href="https://customer.precisely.com/" target="_blank"
                          >Customer Community</a
                        >
                        <a class="dropdown-item" href="https://partner.precisely.com/" target="_blank"
                          >Partner Community</a
                        >
                      </div>
                    </li>
                  }

                  <!-- Support menu -->
                  @if (!isSigningOut) {
                    <li class="nav-item dropdown menu-help">
                      <a
                        aria-expanded="false"
                        aria-haspopup="true"
                        aria-labelledby="help-offscreen"
                        class="nav-link dropdown-toggle"
                        data-bs-toggle="dropdown"
                        href="#"
                        id="help"
                      >
                        <i aria-hidden="true" class="pbi-icon-outline pbi-help-circle d-none d-lg-inline"></i>
                        <span class="d-lg-none" id="help-offscreen">
                          <i aria-hidden="true" class="pbi-icon-mini pbi-help-circle"></i>&nbsp;Support
                        </span>
                      </a>
                      <app-help-menu aria-labelledby="help" class="dropdown-menu" role="menu"></app-help-menu>
                    </li>
                  }

                  <!-- settings menu -->
                  <li class="nav-item dropdown">
                    <a
                      aria-expanded="false"
                      aria-haspopup="true"
                      aria-labelledby="settings-offscreen"
                      class="nav-link dropdown-toggle"
                      data-bs-toggle="dropdown"
                      href="#"
                      id="settingsDropDown"
                    >
                      <i aria-hidden="true" class="pbi-icon-outline pbi-settings d-none d-lg-inline" id="settings"></i>

                      <span class="d-lg-none" id="settings-offscreen">
                        <i aria-hidden="true" class="pbi-icon-mini pbi-settings"></i>&nbsp;Settings
                      </span>
                    </a>
                    <div aria-labelledby="settingsDropDown" class="dropdown-menu" role="menu">
                      <a class="dropdown-item" id="automatic-downloads" routerLink="/autodownload"
                        >Automatic Downloads</a
                      >
                      <a
                        *appHasPermission="'changePassword'"
                        [attr.href]="
                          (isMasterCardUser$ | async) && isNewOktaURLEnabled
                            ? changePasswordUrl
                            : '/user/change-password'
                        "
                        class="dropdown-item"
                        id="change-password"
                        >Change Password</a
                      >
                      <a class="dropdown-item" id="email-notification" routerLink="/user/email-notification"
                        >Email Notification</a
                      >
                      <div class="divider" role="separator"></div>
                    </div>
                  </li>

                  <!-- User menu -->
                  <li
                    (signOut)="logout()"
                    *appHasPermission="'userAccessManagement'"
                    [bodyItems]="(isPdxModernizationEnabled$ | async) ? bodyItemsModern : bodyItemsDefault"
                    [copyrightItems]="copyrightItems"
                    [displayCopyright]="(isMasterCardUser$ | async) === false"
                    [displaySignIn]="false"
                    [displaySignOut]="true"
                    [startYear]="2020"
                    [user]="user$ | async"
                    class="nav-item"
                    png-user-account
                  ></li>
                  <li
                    (signOut)="logout()"
                    *appHasPermission="'!userAccessManagement'"
                    [copyrightItems]="copyrightItems"
                    [displayCopyright]="(isMasterCardUser$ | async) === false"
                    [displaySignIn]="false"
                    [displaySignOut]="true"
                    [startYear]="2020"
                    [user]="user$ | async"
                    class="nav-item"
                    png-user-account
                  ></li>
                  <li *appIfFeature="'start_free_trial_link'">
                    <button (click)="onClick()" class="btn btn-link btn-help" pButton type="button">
                      Start Free Trial
                    </button>
                  </li>
                </ul>
              </div>
            </nav>
          </div>
        </div>
      </div>
    </header>
  </div>
</div>
